import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-upload-input',
  templateUrl: './upload-input.component.html',
  styleUrls: ['./upload-input.component.css'],
  standalone: false
})
export class UploadInputComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;

  @Input() accept: string = '.png, .jpg, .jpeg, .pdf'; // Allowed file types
  @Input() maxFileSize: number = 1; // 1 MB default
  @Input() isInPreviewMode: boolean = false;
  @Output() fileChange = new EventEmitter<{ file: File; readableUrl: string } | null>();
  @Output() error = new EventEmitter<any>();
  @Input() form: FormGroup;
  @Input() controlName: string;

  ngOnInit(): void {
    
  }

  get formControl() {
    return this.form?.get(this.controlName)! as FormControl;
  }

  get formControlValue() {
    console.log('this.formControl?.value', this.formControl?.value)
    return this.formControl?.value as any;
  }




  constructor(private sanitizer: DomSanitizer) {

  }




  triggerUpload(): void {
    if (!this.isInPreviewMode) {
      this.fileInput.nativeElement.click();
    }
  }

  handleFileInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files?.length) {
      const file = input.files[0];
      this.clearFile()

      if (file.size > this.maxFileSize * 1024 * 1024) {
        this.fileInput.nativeElement.value = null;
        // Clear the file input

        this.error.emit({ errorObject: { maxFileSize: true }, message: 'File size exceeds the maximum limit.' });
        return;
      }

      const readableUrl = URL.createObjectURL(file);
      const fileDetails = { file, readableUrl };

      this.fileChange.emit({ file, readableUrl: readableUrl as string });
    }
  }

  clearFile(): void {
    this.fileInput.nativeElement.value = null;
    this.formControl.reset()
    this.fileChange.emit(null);
  }

  isImageFile(file: File): boolean {
    return file?.type?.startsWith('image/');
  }

  isImageUrl(fileUrl: string): boolean {
    return /\.(jpg|jpeg|png)$/i.test(fileUrl);
  }

  isPdfFile(file: File): boolean {
    return file?.type === 'application/pdf' || file?.name?.toLowerCase().endsWith('.pdf');
  }


  isPdfUrl(fileUrl: string): boolean {
    try {
      const url = new URL(fileUrl);
      return url.pathname.toLowerCase().endsWith('.pdf');
    } catch {
      return false; // not a valid URL
    }
  }
}
